import { Modal, Button, Col, Row } from "react-bootstrap";
import { T } from "react-translator-component";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi } from "@fortawesome/free-solid-svg-icons";

const InfoModal = ({ show, setShow, network, pass, hotelCode }) => {

    // const { data: hotel } = useContext(HotelContext)
    return (
        <>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                className={`info-modal info-modal-wifi hotel-${hotelCode}`}
                style={{ height: 260 }}
            >
                <div className="modal-content-custom">
                    <Modal.Body className="modal-body-custom">
                        <div className="text-center p-4 mb-4 flex">
                            <div>
                                <FontAwesomeIcon icon={faWifi} color="#CCC" style={{ fontSize: 50, marginBottom: 30 }} />
                            </div>
                            <h3>{T("status.wifi")}</h3>
                            <p>
                                {T("status.wifi_name")}: <b>{network}</b>
                                <br />
                                {T("status.wifi_password")}: <b>{pass}</b>
                            </p>
                        </div>
                    </Modal.Body>
                </div>
            </Modal >



        </>
    );
};

export default InfoModal;
